import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { SelectField } from 'react-md';
import { NotificationManager } from 'react-notifications';
import { BeatLoader } from 'react-spinners';
import ApiRequestService from '../component/ApiRequestService';
import Properties from '../component/Properties';
import { AppProperties } from '../common/function';
import { Button } from 'react-md';

export default class CourseDropDown extends PureComponent  {
  appProperties = AppProperties();

    constructor(props) {
        super(props);
        this.state = {
          courseListArray: [],
          selectedCourseID: 0,
          selectedCourseIndex: -1,
          loading: true,
          noCourseInSemester:false,
        };
      }

      
    //Loads All Courses on Component Mount
    componentWillMount() {
      console.debug("archivemode ",this.props.archiveMode, this.props.courses)
      if(this.props.archiveMode && this.props.courses){
        this.setState({
          courseListArray: this.props.courses,
          loading: this.props.loading
        });
      }else{
        this.fetchCourses();
      }
        
    }

    componentWillReceiveProps(nextProps)
    {
      console.debug("archivemode ",this.props.archiveMode, this.props.courses)
        if(!nextProps.archiveMode)
        {
            this.fetchCourses();
            
        }else{
          this.setState({
            courseListArray: this.props.courses,
            loading: this.props.loading
          });
        }
    }

    fetchCourses = () => {
      ApiRequestService({
        method: 'post',
        url: '/getAllCourses'
      })
        .then(res => {
          if (
            res.data.data.course_names !== undefined &&
            res.data.data.course_names !== null
          ) {
            let courseArray = res.data.data.course_names.map(
              this.makeCourselistArray
            );
            
            
            this.setState({
              courseListArray: courseArray,
              loading: false
            });
            
          } else {
            (this.appProperties.schoolMode?
              alert('No Standards found. Please add a new Standard and create Sections within it.')
                :
                (
                  this.setState({
                   loading: false,
                   noCourseInSemester: true,
                  })
                )
            )
          }
        })
        .catch(error => {
          console.error(error);
          NotificationManager.error(error,"Error - Empty Response",5000);
        });
    }

    //Create an Array of Courlist for Select Box
    makeCourselistArray(courseObject, index) {
        return {
            key: 'KEY_' + index,
            title: courseObject.course_name,
            value: courseObject.course_id
        };
    }
    onCourseChange = (
        argSelectedCourseID,
        index) => {
        console.debug("onCourseChange index",index,argSelectedCourseID);
    
        this.setState({
          selectedCourseID: argSelectedCourseID,
          selectedCourseIndex: index
        });

        this.props.onChange(argSelectedCourseID);
      };

    render(){
      if (this.state.noCourseInSemester) {
        return (
          <div>
            <div style={{width:'81%',textAlign:'center',position: "absolute",top: "40%"}}>
              <h1 style={{color:"#BB0000",fontSize:"x-large",marginBottom:"20px"}}>
                No courses found in current semester <br/>Please add courses for this semester
              </h1>
                              
              <a href='Courses'>
                <Button  primary  raised className="buttonColour" flat styel={{align:"center",minWidth:"100%"}}>Click here to create Courses</Button></a> </div>
          </div>
        )
      }

        if(this.state.loading)
        {
            return <BeatLoader color='#bb0000' loading={this.state.loading} size={10} />
        }

        return  <SelectField
                            id={this.props.selectBoxID}
                            itemLabel={this.props.itemLabel}
                            className={this.props.className}
                            placeholder={this.props.placeholder}
                            menuItems={this.state.courseListArray}
                            onChange={this.onCourseChange}
                            defaultValue={this.state.selectedCourseID}
                />
    }
}

CourseDropDown.propTypes = {
    onChange: PropTypes.func,
    className:PropTypes.string,
    placeholder:PropTypes.string,
    selectBoxID:PropTypes.string.isRequired,
    archiveMode:PropTypes.bool
    };


  CourseDropDown.defaultProps = {
    itemLabel:"title",
    archiveMode:false
  };

  